/* import __COLOCATED_TEMPLATE__ from './selected-choice-category.hbs.js'; */
import { computed } from "@ember/object";
import { htmlSafe } from "@ember/template";
import { tagName } from "@ember-decorators/component";
import { categoryBadgeHTML } from "discourse/helpers/category-link";
import SelectedChoiceComponent from "select-kit/components/selected-choice";
const SelectedChoiceCategory = dt7948.c(class SelectedChoiceCategory extends SelectedChoiceComponent {
  extraClass = "selected-choice-category";
  get badge() {
    return htmlSafe(categoryBadgeHTML(this.item, {
      allowUncategorized: true,
      link: false
    }));
  }
  static {
    dt7948.n(this.prototype, "badge", [computed("item")]);
  }
}, [tagName("")]);
export default SelectedChoiceCategory;